import { Category, Translation } from '@wix/answers-api';

import { Store } from '.';

export type CategorySlice = {
  category?: Category;
  translations?: Translation[];
  setCategoryData: (data: {
    category?: Category;
    translations?: Translation[];
  }) => void;
};

export const getCategoryInitialState = (
  set: (stateUpdater: (state: Store) => Partial<Store>) => void
): CategorySlice => ({
  category: undefined,
  translations: undefined,
  setCategoryData: (data) => {
    set((state) => ({
      categorySlice: {
        ...state.categorySlice,
        ...data,
      },
    }));
  },
});
